import { capitalizeFirstLetter } from '@cdab/utils'
import { TdsButton, TdsModal } from '@scania/tegel-react'
import parse from 'html-react-parser'
import { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import type { SystemMessageModalProps } from './system-messages-modal.types'

export function SystemMessageModal({
  open,
  onClose,
  systemMessage
}: Readonly<SystemMessageModalProps>) {
  const { t } = useTranslation('common')
  const modalRef = useRef<HTMLTdsModalElement>(null)

  useEffect(() => {
    if (open) {
      modalRef.current?.showModal()
    } else {
      modalRef.current?.closeModal()
    }
  }, [open])

  const handleClose = () => {
    onClose()
  }

  return (
    <TdsModal
      ref={modalRef}
      size='md'
      header={systemMessage.title}
      onTdsClose={handleClose}
    >
      <div slot='body' className='tds-u-mt3 sdds-detail-01'>
        {parse(systemMessage.text)}
      </div>
      <span slot='actions'>
        <TdsButton
          variant='primary'
          onClick={handleClose}
          text={capitalizeFirstLetter(t('close'))}
        />
      </span>
    </TdsModal>
  )
}
